import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";

import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import { useFormik, FormikProvider } from "formik";
import {  Apitoken, Authtoken  } from "../Global";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import $ from "jquery";

const SmallFarmerEdit = () => {
  let { id } = useParams();


  const [value, setValue] = useState({});
  const [backendErrors, setBackendErrors] = useState([]);
  const [permission, setPermission] = useState({});

  const [menu, setMenu] = useState(false);
  const toggleMobileMenu = () => {
    setMenu(!menu);
  };
  

  const formik = useFormik({
    initialValues: {
      id: id,
      contact_number: value.contact_number,
      phone_number: value.phone_number,
      location: value.location,
      region: value.region,
      farm_size:value.farm_size,
      estimated_crops:value.estimated_crops,
      note:value.note
    },
    enableReinitialize: true,
    onSubmit: (values, { setSubmitting }) => {
      axios
        .post("/small-farms/update", values, {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        })
        .then((response) => {
          delete backendErrors['error'];
          $("#form-submit").text("Update Farm"); 
          // actions.setSubmitting(false);
          setSubmitting(false);
          if (response.data.code === 200) {
             toast.success(response.data.message);
            //actions.resetForm();
            setTimeout(() => {
              window.location.href = "/small-farms";
            }, 1000);
          }
            else if (response.data.code === 422) {
              setBackendErrors(response.data.error);
          }
          else if (response.data.code === 401) {
            setBackendErrors(response.data.error);
          }
          else {
             setBackendErrors(response.data.error);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  });


 

  const customHandleInput = (event) => {
    const Input_name = event.target.name;
    delete backendErrors[Input_name];
  };
  useEffect(() => {
        setPermission(FindModuleById(431)); 
      console.log(permission);

    axios
      .get(`/small-farms/edit/${id}`, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        if (response.data.code === 200) {
          setValue(response.data.data.farmer);
        }
      })
      .catch((error) => {
        toast.error(error);
      });

     
 

  }, [id]);

  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />
        <ToastContainer />
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <h3 className="page-title">Small Farms</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/profile">Profile</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/small-farms">
                      Small Farms
                      </Link>
                    </li>
                    <li className="breadcrumb-item active">
                      Edit Farm
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  {permission && permission.update == 1 && (
                    <div className="card-body">
                      <h4 className="card-title">Farm Information</h4>
                      <FormikProvider value={formik}>
                        <form action="#" onSubmit={formik.handleSubmit}>
                          <div className="row">
                            <div className="col-md-6">
                              <div className="form-group">
                                  <label>Contact Number </label>
                                  <input
                                    type="text"
                                    name="contact_number"
                                    value={formik.values.contact_number}
                                    className= "form-input form-control"
                                    onChange={(e) => {
                                      formik.handleChange(e);
                                      customHandleInput(e);
                                    }}
                                    onBlur={formik.handleBlur}
                                  />
                                  <small>
                                    {backendErrors.contact_number && (
                                        <span className="form-error mt-1">
                                          {backendErrors.contact_number}
                                        </span>
                                      )}
                                  </small>
                                </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-group">
                                  <label>Phone Number </label>
                                  <input
                                    type="text"
                                    name="phone_number"
                                    value={formik.values.phone_number}
                                    className= "form-input form-control"
                                    onChange={(e) => {
                                      formik.handleChange(e);
                                      customHandleInput(e);
                                    }}
                                    onBlur={formik.handleBlur}
                                  />
                                  <small>
                                    {backendErrors.phone_number && (
                                        <span className="form-error mt-1">
                                          {backendErrors.phone_number}
                                        </span>
                                      )}
                                  </small>
                                </div>
                            </div>

                          <div className="col-md-6">
                              <div className="form-group">
                                  <label>GPS Location</label>
                                  <input
                                    type="text"
                                    name="location"
                                    value={formik.values.location}
                                    className="form-input form-control"
                                    onChange={(e) => {
                                      formik.handleChange(e);
                                      customHandleInput(e);
                                    }}
                                    onBlur={formik.handleBlur}
                                  />
                                  <small>
                                    {backendErrors.location && (
                                        <span className="form-error mt-1">
                                          {backendErrors.location}
                                        </span>
                                      )}
                                  </small>
                                </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-group">
                                  <label>region</label>
                                  <input
                                    type="text"
                                    name="region"
                                    value={formik.values.region}
                                    className= "form-input form-control"
                                    onChange={(e) => {
                                      formik.handleChange(e);
                                      customHandleInput(e);
                                    }}
                                    onBlur={formik.handleBlur}
                                  />
                                  <small>
                                    {backendErrors.region && (
                                        <span className="form-error mt-1">
                                          {backendErrors.region}
                                        </span>
                                      )}
                                  </small>
                                </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-group">
                                      <label>Farm Size</label>
                                      <div className="input-group">
                                          <input 
                                          type="text"
                                          onKeyPress={(event) => {
                                            // Allow only numbers (0-9)
                                            if (!/^[0-9]$/.test(event.key)) {
                                            event.preventDefault();
                                            }
                                          }}
                                          name="farm_size"
                                          value={formik.values.farm_size}
                                          onChange={(e) => {
                                            formik.handleChange(e);
                                            customHandleInput(e);
                                          }}
                                          onBlur={formik.handleBlur}
                                          className="form-control" placeholder="Farm Size" aria-label="Farm Size" aria-describedby="basic-addon2" />
                                          <div className="input-group-append">
                                              <span className="input-group-text" id="basic-addon2">Hectares</span>
                                          </div>
                                      </div>
                                      <small>
                                          {backendErrors.farm_size && (
                                              <span className="form-error mt-1">
                                                {backendErrors.farm_size}
                                              </span>
                                            )}
                                        </small>
                              
                                  
                                </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-group">
                                  <label>Estimated Crops</label>
                                      <div className="input-group">
                                          <input 
                                          type="text"
                                          onKeyPress={(event) => {
                                            // Allow only numbers (0-9)
                                            if (!/^[0-9]$/.test(event.key)) {
                                            event.preventDefault();
                                            }
                                          }}
                                          name="estimated_crops"
                                          value={formik.values.estimated_crops}
                                          onChange={(e) => {
                                            formik.handleChange(e);
                                            customHandleInput(e);
                                          }}
                                          onBlur={formik.handleBlur}
                                          className="form-control" placeholder="Estimated Crops" aria-label="Estimated Crops" aria-describedby="basic-addon2" />
                                          <div className="input-group-append">
                                              <span className="input-group-text" id="basic-addon2">Tonnes</span>
                                          </div>
                                      </div>
                                
                                  <small>
                                    {backendErrors.estimated_crops && (
                                        <span className="form-error mt-1">
                                          {backendErrors.estimated_crops}
                                        </span>
                                      )}
                                  </small>
                                </div>
                            </div>
                          

                            <div className="col-md-12">
                              <div className="form-group">
                                  <label>Note</label>
                                  <textarea
                                  
                                    name="note"
                                    value={formik.values.note}
                                    className="form-input form-control"
                                    onChange={(e) => {
                                      formik.handleChange(e);
                                      customHandleInput(e);
                                    }}
                                    onBlur={formik.handleBlur}
                                  ></textarea>
                                  <small>
                                    {backendErrors.note && (
                                        <span className="form-error mt-1">
                                          {backendErrors.note}
                                        </span>
                                      )}
                                  </small>
                                </div>
                            </div>

                          </div>
                        
                          
                          <div className="text-end mt-4">
                            <button type="submit" id="form-submit" className="btn btn-primary" disabled={formik.isSubmitting}>
                              Update Small Farm
                            </button>
                          </div>
                        </form>
                      </FormikProvider>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default SmallFarmerEdit;
